module["exports"] = [
  "Erik",
  "Lars",
  "Karl",
  "Anders",
  "Per",
  "Johan",
  "Nils",
  "Lennart",
  "Emil",
  "Hans"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/name/first_name_men.js
 ** module id = 1081
 ** module chunks = 0
 **/